"use client";

import React from "react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function PrivacyPolicy() {
  const {
    ref: sectionRef,
    isVisible
  } = useRevealOnScroll<HTMLElement>({
    threshold: 0.1,
    once: true
  });
  return <section id="privacy-policy" data-nav="light" ref={sectionRef} className="bg-background text-foreground py-16 md:py-20 border-b border-border">
      <div className="max-w-[1136px] mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-8">
          <div className={`md:col-start-3 md:col-span-8 transition-opacity duration-700 ease-out ${isVisible ? "opacity-100" : "opacity-0"}`}>
            {/* Header Block */}
            <div className="mb-10">
              <h1 className="text-3xl sm:text-4xl md:text-5xl font-bold tracking-tight text-foreground font-default mb-4">
                Datenschutzerklärung
              </h1>

              <div className="flex items-center gap-3">
                <span className="text-sm font-medium text-muted-foreground">
                  Zuletzt aktualisiert: Januar 2025
                </span>
                {/* Signature hairline rule capped with a crisp turquoise terminal dot */}
                <div className="flex-1 flex items-center gap-1.5" aria-hidden="true">
                  <div className="h-px bg-border flex-1" />
                  <div className="size-2 rounded-full bg-primary shrink-0" />
                </div>
              </div>

              <p className="text-sm text-muted-foreground mt-3">
                Betreiber: Ahmed Kamal Hussein Abdel-Aal.
              </p>
            </div>

            {/* Continuous Legal Text */}
            <div className="space-y-8 text-foreground/90 font-default text-base leading-relaxed">
              <p className="text-lg text-foreground font-normal leading-relaxed">
                Hurghada Transfer Hub (&bdquo;wir&ldquo;, &bdquo;unser&ldquo; oder &bdquo;uns&ldquo;) respektiert Ihre Privatsphäre und verpflichtet sich zum Schutz der personenbezogenen Daten, die Sie bei der Nutzung unserer Website und unserer privaten Transferdienste in Ägypten angeben.
              </p>

              <div className="border-t border-border/80 pt-6">
                <h2 className="text-xl font-semibold text-foreground mb-3 tracking-tight">
                  Informationen, die wir erfassen
                </h2>
                <p className="text-muted-foreground leading-relaxed">
                  Wenn Sie einen Transfer anfragen oder mit uns Kontakt aufnehmen, erfassen wir die erforderlichen personenbezogenen Daten wie Ihren Namen, Ihre E-Mail-Adresse, Ihre WhatsApp- oder Telefonnummer, Flugdaten, den Abholort und das Zielresort. Diese Informationen werden ausschließlich dazu erhoben, Ihren privaten Transfer zu koordinieren und auszuführen.
                </p>
              </div>

              <div className="border-t border-border/80 pt-6">
                <h2 className="text-xl font-semibold text-foreground mb-3 tracking-tight">
                  Wie wir Ihre Informationen nutzen
                </h2>
                <p className="text-muted-foreground leading-relaxed">
                  Wir nutzen die erfassten Angaben (einschließlich Ihrer Flugdaten), um Reservierungen zu bestätigen, die Ankunftszeit sowie eventuelle Verspätungen Ihres Fluges zu verfolgen, Abholdetails via WhatsApp oder E-Mail zu übermitteln und sicherzustellen, dass unser Fahrer Sie zum vereinbarten Treffzeitpunkt empfängt. Wir verkaufen, vermieten oder übertragen Ihre personenbezogenen Daten nicht an Dritte.
                </p>
              </div>

              <div className="border-t border-border/80 pt-6">
                <h2 className="text-xl font-semibold text-foreground mb-3 tracking-tight">
                  Datenspeicherung und Datensicherheit
                </h2>
                <p className="text-muted-foreground leading-relaxed">
                  Ihre Buchungsdaten werden in sicheren internen Datenbanken gespeichert, auf die ausschließlich autorisiertes Dispositionspersonal Zugriff hat. Wir setzen strenge administrative Sicherheitsmaßnahmen ein, um unbefugten Zugriff auf Ihre Daten oder deren unberechtigte Weitergabe zu verhindern.
                </p>
              </div>

              <div className="border-t border-border/80 pt-6">
                <h2 className="text-xl font-semibold text-foreground mb-3 tracking-tight">
                  Ihre Rechte
                </h2>
                <p className="text-muted-foreground leading-relaxed">
                  Sie können jederzeit die Einsichtnahme, Berichtigung oder Löschung Ihrer gespeicherten Buchungsdaten anfordern. Wenden Sie sich dazu bitte an unsere Datenschutzstelle unter{" "}
                  <a href="mailto:info@hurghadatransferhub.com" className="text-primary hover:text-primary/80 font-medium underline underline-offset-4 decoration-primary/40 transition-colors">
                    info@hurghadatransferhub.com
                  </a>{" "}
                  oder per WhatsApp unter{" "}
                  <a href="tel:+201010634627" className="text-primary hover:text-primary/80 font-medium underline underline-offset-4 decoration-primary/40 transition-colors">
                    +20 10 10634627
                  </a>
                  .
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}